<template>
    <div v-if="isAvailable">
        <b-btn @click="showModal" class="btn-card-action btn-card-action-orange my-1">Отменить закупку</b-btn>
        <b-modal ref="cancel-modal" :title="title" v-model="isModalVisible" no-close-on-backdrop no-close-on-esc hide-header-close centered size="lg">
            <b-row>
                <b-col md="12">
                    <p class="fs-16 font-weight-bold grey-color">Введите причину отмены закупки и/или приложите документ с обоснованием причины отмены закупки. Данная информация будет отправлена поставщикам, подавшим предложения, а также будет видна сотрудникам ГК и Вашего ГРБС.</p>
                </b-col>
            </b-row>
            <form-row-edit-textarea label="Введите причину отмены закупки" v-model="purchaseCancelingReasonMessage" :rows="8" />
            <form-row-single-line-document-upload title="Обоснование причины отмены закупки" v-model="purchaseCancelingDocument" />
            <div slot="modal-footer" class="w-100 text-right">
                <b-overlay :show="isDataSending" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
                    <b-button variant="custom-outline-secondary" class="text-uppercase mr-2" @click="cancelModal">Нет</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
                    <b-button variant="custom-danger" class="text-uppercase" :disabled="!isDataValid" @click="cancelPurchase">Отменить закупку</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'cabinet-fl44-notice-card-cancel-button',
    props: {
        purchase: {
            type: Object
        }
    },
    data() {
        return {
            isModalVisible: false,
            purchaseCancelingReasonMessage: '',
            purchaseCancelingDocument: null,
            isDataSending: false
        };
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
            this.purchaseCancelingReasonMessage = '';
            this.purchaseCancelingDocument = null;
        },
        cancelModal() {
            this.isModalVisible = false;
        },
        async cancelPurchase() {
            this.isDataSending = true;
            const payload = {
                purchase_canceling_reason_message: this.purchaseCancelingReasonMessage,
                purchase_canceling_stored_document_id: this.purchaseCancelingDocument ? this.purchaseCancelingDocument.id : null
            };
            if (await this.$api.personal[this.purchase.type === 'fl44' ? 'fl44' : 'fl44UnknownVolume'].cancelPurchase(this.purchase.id, payload)) {
                this.cancelModal();
                this.$emit('action');
            }
            this.isDataSending = false;
        }
    },
    computed: {
        title() {
            return `Отменить закупку № ${this.purchase.purchase_info.reg_number}?`;
        },
        isAvailable() {
            return this.purchase.actions.cancel;
        },
        isDataValid() {
            return this.purchaseCancelingReasonMessage.trim().length > 0 || (this.purchaseCancelingDocument !== null && this.purchaseCancelingDocument.id !== null);
        }
    }
};
</script>
